export default {
  "ad.changePw": "Change password",
  "ad.logout": "Log out",
  "cf.language": "Language",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.search": "Search",
  "common.loading": "Loading...",
  "common.confirm": "Confirm",
  "common.back": "Back",
  "common.yes": "Yes",
  "common.no": "No",
  "dash.title": "Dashboard",
  "dash.today": "Today",
  "dash.week": "Week",
  "dash.month": "Month",
  "dash.fiado": "Store credit due",
  "dash.salesDone": "Completed sales",
  "dash.openOrders": "Open orders",
  "dash.openOS": "Open work orders",
  "dash.lowStock": "Low stock",
  "dash.rev30": "Revenue — last 30 days",
  "dash.topProducts": "Top Products",
  "dash.sellers": "Sellers",
  "dash.noData": "No data",
  "dash.product": "Product",
  "dash.qty": "Qty",
  "dash.revenue": "Revenue",
  "dash.seller": "Seller",
  "dash.sales": "Sales",
  "dash.total": "Total",
  "dash.reports": "Reports",
  "dash.lowStockTitle": "Low Stock",
  "dash.belowMin": "{n} products below minimum",
  "dash.print": "Print",
  "dash.stock": "Stock",
  "dash.min": "Minimum",
  "dash.missing": "Missing",
  "dash.unitPrice": "Unit Price",
  "dash.totalSale": "Total Sale",
  "dash.restock": "Total to restock:",
  "login.tagline": "From chaos to clarity — Aurora lights up your management",
  "login.title": "Sign in to your account",
  "login.password": "Password",
  "login.enter": "Sign in",
  "login.loggingIn": "Signing in...",
  "login.plans": "See plans & pricing",
  "login.noAccount": "Don't have an account yet?",
  "login.trial": "Free 15-day Trial ☀",
  "menu.dashboard": "Dashboard",
  "menu.clients": "Clients",
  "menu.products": "Products & Stock",
  "menu.sales": "Sales",
  "menu.os": "Work Orders",
  "menu.trocas": "Exchanges & Returns",
  "menu.cash": "Cash Register",
  "menu.financial": "Finance",
  "menu.reports": "Reports",
  "menu.fiscal": "Invoice",
  "menu.support": "Support",
  "menu.config": "Settings",
  "menu.admin": "Admin Panel",
  "os.title": "Work Orders",
  "os.count": "{n} registered",
  "os.new": "+ New WO",
  "os.fAll": "All",
  "os.fOpen": "Open",
  "os.fRepair": "In repair",
  "os.fDone": "Finished",
  "os.fPaid": "Paid",
  "os.fCanceled": "Canceled",
  "os.client": "Client",
  "os.desc": "Description",
  "os.total": "Total",
  "os.status": "Status",
  "os.actions": "Actions",
  "os.view": "View",
  "os.start": "Start",
  "os.finish": "Finish",
  "os.cancelConfirm": "Cancel WO #{n}? Stock will be reverted.",
  "os.editTitle": "Edit WO",
  "os.osNum": "WO No.",
  "os.labor": "Labor",
  "os.parts": "Parts used",
  "os.searchPart": "Search part...",
  "os.part": "Part",
  "os.qty": "Qty",
  "os.value": "Price",
  "os.subtotal": "Subtotal",
  "os.partsSum": "Parts",
  "os.saving": "Saving...",
  "os.tech": "Technician",
  "os.item": "Item",
  "os.print": "Print",
  "os.printTitle": "WORK ORDER No.",
  "os.newTitle": "New Work Order",
  "os.newClient": "+ New",
  "os.promptName": "Client name:",
  "os.promptPhone": "Phone (optional):",
  "os.promptType": "Type: PF, PJ or Reseller",
  "os.select": "Select...",
  "os.obs": "Notes",
  "os.descPh": "E.g.: iPhone 12 screen replacement",
  "os.totalValue": "Work Order Total",
  "os.create": "Create WO",
  "os.exceed": "⚠ Parts exceed the work order total",
  "os.error": "Error: ",
  "st.em_aberto": "open",
  "st.em_reparo": "in repair",
  "st.finalizado": "finished",
  "st.pago": "paid",
  "st.cancelado": "canceled",
  "cl.title": "Clients",
  "cl.count": "{n} registered",
  "cl.exportCsv": "Export CSV",
  "cl.importCsv": "Import CSV",
  "cl.new": "+ New",
  "cl.searchPh": "Search...",
  "cl.debtors": "Debtors",
  "cl.credit": "Credit",
  "cl.name": "Name",
  "cl.type": "Type",
  "cl.phone": "Phone",
  "cl.city": "City",
  "cl.debt": "Debt",
  "cl.actions": "Actions",
  "cl.deleteConfirm": "Are you sure you want to delete this client?",
  "cl.importEmpty": "No clients found in the file",
  "cl.importConfirm": "Import {n} clients?",
  "cl.formEdit": "Edit client",
  "cl.formNew": "New client",
  "cl.ficha": "Client Record",
  "cl.creditBalance": "Credit Balance",
  "cl.hasCredit": "Client has available credit",
  "cl.hasDebt": "Client has pending debt",
  "cl.noBalance": "No balance",
  "cl.history": "History",
  "cl.noMoves": "No transactions",
  "cl.payDebt": "Pay Down Debt",
  "cl.amount": "Amount",
  "cl.method": "Method",
  "cl.cash": "Cash",
  "cl.card": "Card",
  "cl.other": "Other",
  "cl.obsLabel": "Note",
  "cl.obsMandatory": " (required)",
  "cl.obsPh": "Service exchanged, material sent...",
  "cl.obsRequired": "Note is required for payment type Other",
  "cl.processing": "Processing...",
  "cl.confirmPay": "Confirm Payment",
  "cl.error": "Error: ",
  "sl.title": "Sales",
  "sl.tabNew": "New sale",
  "sl.tabOrders": "Orders",
  "sl.tabSearch": "Search",
  "sl.searchProdPh": "Search by product name...",
  "sl.searching": "Searching...",
  "sl.noResults": "No results",
  "sl.minChars": "Type at least 2 characters",
  "sl.order": "Order",
  "sl.date": "Date",
  "sl.client": "Client",
  "sl.seller": "Seller",
  "sl.product": "Product",
  "sl.qty": "Qty",
  "sl.price": "Price",
  "sl.status": "Status",
  "sl.walkin": "Walk-in",
  "sl.noPerm": "No permission",
  "sl.orderOpened": "Order opened!",
  "sl.retail": "Retail",
  "sl.wholesale": "Wholesale",
  "sl.searchClientPh": "Search client...",
  "sl.creditAvail": "Available credit: ",
  "sl.debtPending": "Pending debt: ",
  "sl.searchProdPh2": "Search product...",
  "sl.addProducts": "Add products",
  "sl.discCol": "Disc. R$",
  "sl.obsPh": "Note (optional)",
  "sl.summary": "Summary",
  "sl.disc": "Disc.",
  "sl.discShort": "Disc",
  "sl.saveChanges": "Save Changes",
  "sl.openOrder": "Open order",
  "sl.fAll": "All",
  "sl.fOpen": "Open",
  "sl.fFiado": "On credit",
  "sl.fDone": "Finished",
  "sl.payment": "Pay",
  "sl.reopen": "Reopen",
  "sl.orderCaps": "ORDER",
  "sl.printOrder": "ORDER No.",
  "sl.discItems": "Item disc.",
  "sl.discGeneral": "General disc.",
  "sl.payMethods": "Payment Methods:",
  "sl.payMethod": "Payment Method:",
  "sl.payAtCash": "Payment must be made at the Cash Register",
  "sl.fiadoConfirm": "Mark order #{n} as ON CREDIT? The amount will be recorded as client debt.",
  "sl.sellFiado": "Sell on Credit",
  "sl.fiadoNotice": "ON CREDIT — Payment pending. Collect at the Cash Register to settle.",
  "sl.error": "Error: ",
  "st.aberto": "open",
  "st.fiado": "on credit",
  "st.concluído": "completed",
  "pr.title": "Products & Stock",
  "pr.count": "{n} registered",
  "pr.allCats": "All",
  "pr.brand": "Brand",
  "pr.category": "Category",
  "pr.stock": "Stock",
  "pr.min": "Minimum",
  "pr.label": "Label",
  "pr.deleteConfirm": "Are you sure you want to delete this product?",
  "pr.importEmpty": "No products found in the file",
  "pr.importConfirm": "Import {n} products?",
  "pr.prev": "Previous",
  "pr.next": "Next",
  "pr.pageOf": "Page {a} of {b} ({n} products)",
  "pr.ficha": "Product Record",
  "pr.currentStock": "Current Stock",
  "pr.addStock": "Add Stock",
  "pr.launch": "+ Add",
  "pr.stockLoad": "Stock load",
  "pr.reasonPh": "Reason (e.g.: Supplier purchase)",
  "pr.reason": "Reason",
  "pr.moves": "Movements",
  "pr.noMoves": "No movements recorded",
  "pr.formEdit": "Edit",
  "pr.formNew": "New",
  "pr.newCat": "+ New",
  "pr.newCatPrompt": "New category name:",
  "pr.cost": "Cost",
  "pr.tiers": "Volume Price Tiers",
  "pr.tiersClose": "▲ Close",
  "pr.tiersAdd": "▼ Add",
  "pr.from": "From",
  "pr.unitArrow": "un →",
  "pr.addTier": "+ Add tier",
  "pr.error": "Error: ",
  "st.entrada": "in",
  "st.saida": "out",
  "tr.tabMain": "Exchanges/Returns",
  "tr.tabSupplier": "Supplier returns",
  "tr.new": "+ New Exchange/Return",
  "tr.formTitle": "New Exchange / Return",
  "tr.byOrder": "By Order No.",
  "tr.byProduct": "By Product",
  "tr.orderNum": "Order No.",
  "tr.orderNumPh": "Type the order number...",
  "tr.productName": "Product Name",
  "tr.productNamePh": "Type the product name...",
  "tr.notFinalized": "Order #{n} is not finished (status: {s})",
  "tr.notFound": "Order #{n} not found",
  "tr.noSaleFound": "No sale found with that product",
  "tr.consumer": "Consumer",
  "tr.opType": "Operation Type",
  "tr.return": "Return",
  "tr.exchange": "Exchange",
  "tr.selectItems": "Order Items — select the one(s) to be returned",
  "tr.returnCol": "Return",
  "tr.returnedTotal": "Returned total:",
  "tr.newProducts": "New Product(s)",
  "tr.newProdPh": "Search new product...",
  "tr.stAbbr": "stk",
  "tr.newProduct": "New Product",
  "tr.newTotal": "New total:",
  "tr.returnedValue": "Returned value:",
  "tr.newValue": "New value:",
  "tr.difference": "Difference:",
  "tr.noDiff": "No difference",
  "tr.clientReceives": "Client receives ",
  "tr.clientPays": "Client pays ",
  "tr.howCredit": "How to settle the credit?",
  "tr.howDebit": "How to settle the debit?",
  "tr.creditFicha": "Credit on record",
  "tr.debitFicha": "Debit on record",
  "tr.refundPix": "Refund PIX",
  "tr.chargePix": "Charge PIX",
  "tr.refundCash": "Refund cash",
  "tr.chargeCash": "Charge cash",
  "tr.refundCard": "Refund card",
  "tr.chargeCard": "Charge card",
  "tr.obsOptional": "Note (optional)",
  "tr.obsPh": "Reason for exchange/return...",
  "tr.returned": "Returned",
  "tr.newOnes": "New",
  "tr.credit": "Credit",
  "tr.debit": "Debit",
  "tr.onFicha": "Recorded on client record",
  "tr.via": "Via ",
  "tr.success": "completed successfully!",
  "tr.resolution": "Resolution",
  "tr.none": "No exchanges/returns recorded",
  "tr.noneF": "None",
  "tr.cancelTitle": "Cancel Exchange/Return",
  "tr.cancelWarn": "This action will revert stock, client credit and financial records.",
  "tr.reasonOptional": "Reason (optional)",
  "tr.cancelReasonPh": "Cancellation reason...",
  "tr.cancelling": "Cancelling...",
  "tr.confirmCancel": "Confirm Cancellation",
  "tr.supplier": "Supplier",
  "tr.error": "Error: ",
  "tr.cancelError": "Error cancelling: ",
  "st.troca": "exchange",
  "st.devolucao": "return",
  "st.concluido": "completed",
  "cx.title": "Cash Register",
  "cx.open": "Register open",
  "cx.closed": "Register closed",
  "cx.tabCash": "Register",
  "cx.tabMoves": "Movements",
  "cx.tabConf": "Audit",
  "cx.openCash": "Open Register",
  "cx.initial": "Starting amount (change)",
  "cx.opening": "Opening...",
  "cx.cashMsg": "Register opened!",
  "cx.receive": "Receive Payments",
  "cx.noItems": "No items",
  "cx.selectPending": "Select a pending order",
  "cx.discount": "Discount",
  "cx.or": "or",
  "cx.payForm": "Payment Method",
  "cx.useCredit": "Use Credit",
  "cx.saleTotal": "Sale Total",
  "cx.received": "Total Received",
  "cx.change": "Change (cash)",
  "cx.fiado": "On credit",
  "cx.selectMethod": "Select a payment method",
  "cx.printReceipt": "Print receipt?",
  "cx.fiadoMsg": "Recorded as store credit!",
  "cx.payMsg": "Payment confirmed!",
  "cx.sangria": "Cash out (withdrawal)",
  "cx.suprimento": "Cash in (deposit)",
  "cx.reason": "Reason",
  "cx.sangriaMsg": "Cash out recorded!",
  "cx.suprimMsg": "Cash in recorded!",
  "cx.sangriaDefault": "Cash out",
  "cx.suprimDefault": "Cash in",
  "cx.pending": "Pending Orders",
  "cx.noPending": "None pending",
  "cx.closeCash": "Close Register",
  "cx.expected": "Expected balance:",
  "cx.credits": "Credits",
  "cx.optional": "Optional",
  "cx.closing": "Closing...",
  "cx.matched": "Balanced perfectly ✓",
  "cx.over": "Over by R$ ",
  "cx.short": "Short by R$ ",
  "cx.reported": "Reported",
  "cx.movesTitle": "Register Movements",
  "cx.histTitle": "Register History",
  "cx.opened": "Opened",
  "cx.closedAt": "Closed",
  "cx.operator": "Operator",
  "cx.initialCol": "Initial",
  "cx.expectedCol": "Expected",
  "cx.diff": "Difference",
  "cx.noClosed": "No closed registers",
  "cx.matchShort": "✓ Balanced",
  "cx.check": "Review",
  "cx.confTitle": "Register Audit",
  "cx.openLbl": "open",
  "cx.matchedShort": "Balanced ✓",
  "cx.hour": "Time",
  "cx.products": "Products",
  "cx.paymentCol": "Payment",
  "cx.balance": "Balance",
  "cx.sangrias": "Cash outs",
  "cx.suprimentos": "Cash ins",
  "cx.estornos": "Reversals",
  "cx.prazo": "On terms",
  "cx.searchPh": "Search order, client...",
  "cx.noMoves": "No movements",
  "cx.detailsUnavail": "Details unavailable",
  "cx.discItem": "Item Disc",
  "cx.discGeneralLine": "General discount:",
  "st.venda": "sale",
  "st.divida": "debt",
  "st.pagamento_venda": "sale pmt",
  "st.pagamento_os": "WO pmt",
  "st.pagamento_divida": "debt pmt",
  "st.estorno_reabertura": "reopen reversal",
  "st.ajuste_edicao": "edit adjustment",
  "st.cancelamento": "cancellation",
  "st.sangria": "cash out",
  "st.suprimento": "cash in",
  "pay.pix": "PIX",
  "fn.title": "Finance",
  "fn.count": "{n} entries",
  "fn.tabSummary": "Summary",
  "fn.tabPay": "Payables",
  "fn.tabReceive": "Receivables",
  "fn.required": "Description and amount are required",
  "fn.created": "Entry created!",
  "fn.paidMsg": "Marked as paid!",
  "fn.deleteConfirm": "Delete entry?",
  "fn.receivedLbl": "Received:",
  "fn.paidLbl": "Paid:",
  "fn.pendingLbl": "Pending:",
  "fn.balanceLbl": "Balance (realized)",
  "fn.inOut": "Actual inflows - outflows",
  "fn.overdue": "Overdue",
  "fn.dueSoon": "Due within 5 days",
  "fn.dueAbbr": "due",
  "fn.pay": "Pay",
  "fn.receive": "Receive",
  "fn.new": "+ New Entry",
  "fn.newTitle": "New Entry",
  "fn.allStatus": "All statuses",
  "fn.pending": "Pending",
  "fn.paid": "Paid",
  "fn.catPh": "E.g.: Supplier, Rent",
  "fn.due": "Due date",
  "fn.supplierOrigin": "Supplier/Origin",
  "fn.none": "No entries",
  "st.pendente": "pending",
  "rp.title": "Reports",
  "rp.results": "{n} results",
  "rp.filters": "Filters",
  "rp.dateFrom": "From date",
  "rp.dateTo": "To date",
  "rp.dateFmt": "DD/MM/YYYY",
  "rp.namePh": "Name...",
  "rp.commissionPct": "Commission %",
  "rp.generate": "Generate report",
  "rp.generating": "Generating...",
  "rp.clear": "Clear",
  "rp.revenue": "Revenue",
  "rp.orders": "Orders",
  "rp.avgTicket": "Avg ticket",
  "rp.itemsSold": "Items sold",
  "rp.noneFiltered": "No orders with these filters",
  "rp.byCat": "By category",
  "rp.commissions": "Commissions",
  "rp.commission": "Commission",
  "rp.totalCaps": "TOTAL",
  "rp.hint": "Select filters and click Generate report",
  "rp.noSeller": "No seller",
  "rp.noCat": "No cat.",
  "rp.error": "Error: ",
  "rp.printTitle": "Aurora Report",
  "rp.printHeader": "Sales Report",
  "rp.ordersLbl": "orders",
  "rp.itemsLbl": "items",
  "rp.generatedBy": "Generated by Aurora by Neurotech-X on",
  "fs.title": "Electronic Invoice (Brazil)",
  "fs.subtitle": "Tax setup and issuance via Focus NFe",
  "fs.tabNotes": "Invoices",
  "fs.tabConfig": "Settings",
  "fs.issued": "Issued Invoices",
  "fs.refresh": "↻ Refresh",
  "fs.emit": "+ Issue Invoice",
  "fs.none": "No invoices issued yet",
  "fs.number": "Number",
  "fs.emitTitle": "Issue Invoice",
  "fs.clientOpt": "Client (optional)",
  "fs.recipient": "Recipient *",
  "fs.items": "Items *",
  "fs.addItem": "+ Item",
  "fs.unitPrice": "Unit Price",
  "fs.payment": "Payment *",
  "fs.addPay": "+ Method",
  "fs.payForm": "Method",
  "fs.valueEmpty": "Amount (empty=total)",
  "fs.emitting": "Issuing...",
  "fs.emitBtn": "Issue",
  "fs.authorized": "✅ Invoice authorized! No. ",
  "fs.sent": "⏳ Invoice sent",
  "fs.configSaved": "Settings saved!",
  "fs.error": "Error: ",
  "fs.saveConfig": "Save Settings",
  "st.autorizada": "authorized",
  "st.erro": "error",
  "tk.title": "Support",
  "tk.count": "{n} tickets",
  "tk.new": "+ New Ticket",
  "tk.tabOpen": "Open",
  "tk.tabClosed": "Resolved",
  "tk.noneOpen": "No open tickets. All good! ☀",
  "tk.noneClosed": "No resolved tickets yet.",
  "tk.newTitle": "New Ticket",
  "tk.newSub": "Describe your problem or question",
  "tk.back": "← Back",
  "tk.subject": "Subject *",
  "tk.subjectPh": "E.g.: Error finishing a sale",
  "tk.descPh": "Detail the problem, steps to reproduce...",
  "tk.priority": "Priority",
  "tk.creating": "Creating...",
  "tk.openTicket": "Open Ticket",
  "tk.subjectRequired": "Enter a subject",
  "tk.rateRequired": "Select a rating",
  "tk.supportName": "Neurotech-X Support",
  "tk.you": "You",
  "tk.attachment": "📎 Attachment",
  "tk.noMessages": "No messages yet",
  "tk.rated": "You rated this support",
  "tk.ratePrompt": "Ticket closed. Want to rate the support? (optional)",
  "tk.commentPh": "Comment (optional)",
  "tk.sending": "Sending...",
  "tk.sendRating": "Send Rating",
  "tk.msgPh": "Type your message... (Enter to send)",
  "tk.send": "Send",
  "tk.st_aberto": "Open",
  "tk.st_em_atendimento": "In Progress",
  "tk.st_fechado": "Closed",
  "tk.pr_baixa": "low",
  "tk.pr_normal": "normal",
  "tk.pr_alta": "high",
  "tk.pr_urgente": "urgent",
  "cf.title": "Settings",
  "cf.subtitle": "Manage your company and users",
  "cf.tabCompany": "Company Data",
  "cf.tabUsers": "Users & Permissions",
  "cf.tabLabels": "Labels",
  "cf.companyInfo": "Company Information",
  "cf.companyName": "Company Name *",
  "cf.companyNameLbl": "Company Name",
  "cf.address": "Address",
  "cf.addressPh": "Street, number, district",
  "cf.state": "State",
  "cf.logoUrl": "Logo URL (optional)",
  "cf.logoHint": "The logo will appear on printouts (orders, WOs). Recommended: PNG image up to 200x80px.",
  "cf.logoPreview": "Logo preview:",
  "cf.saveCompany": "Save Company Data",
  "cf.companySaved": "Company data saved!",
  "cf.headerPreview": "Header Preview (printouts)",
  "cf.labelConfig": "Configure Label Template",
  "cf.labelHint": "Set the size and fields shown on your product labels. The template is used when printing labels from the Products screen.",
  "cf.width": "Width (mm)",
  "cf.height": "Height (mm)",
  "cf.fontSize": "Font Size (px)",
  "cf.labelFields": "Label Fields (enable/disable)",
  "cf.fName": "Product Name",
  "cf.fRetail": "Retail Price",
  "cf.fWholesale": "Wholesale Price",
  "cf.fLogo": "Company Logo",
  "cf.fBarcode": "Barcode",
  "cf.saveLabel": "Save Label Template",
  "cf.labelPreview": "Label Preview",
  "cf.sampleProduct": "Sample Product",
  "cf.realSize": "Actual size:",
  "cf.scale3x": "(preview at 3x scale)",
  "cf.usersCount": "{n} users",
  "cf.newUser": "+ New User",
  "cf.newUserTitle": "New User",
  "cf.create": "Create",
  "cf.fillAll": "Fill in all fields",
  "cf.userCreated": "User created!",
  "cf.active": "Active",
  "cf.inactive": "Inactive",
  "cf.resetPassword": "Reset Password",
  "cf.resetPrompt": "New password for {n} (leave EMPTY to auto-generate):",
  "cf.tempPassword": "Temporary password for {n} — copy now, it won't be shown again:",
  "cf.resetDone": "Password reset! The user must change it at next login.",
  "cf.permissions": "Permissions",
  "cf.module": "Module",
  "cf.specialPerms": "Special Permissions",
  "cf.capDiscount": "Give Discount",
  "cf.capReopen": "Reopen Order",
  "cf.capCancel": "Cancel Order",
  "cf.capFiado": "Sell on Credit",
  "cf.capCloseCash": "Close Register",
  "cf.capConference": "View Audit",
  "cf.savePerms": "Save Permissions",
  "cf.permsSaved": "Permissions saved!",
  "cf.modExchanges": "Exchanges",
  "cf.modFiscal": "Tax",
  "pl.title": "Aurora Plans",
  "pl.subtitle": "Choose the ideal plan for your business",
  "pl.popular": "MOST POPULAR",
  "pl.select": "SELECT",
  "pl.perMonth": "/month",
  "pl.includes": "INCLUDES:",
  "pl.users": "{n} users",
  "pl.unlimited": "Unlimited",
  "pl.subscribe": "Subscribe to",
  "pl.aiChip": "✓ AI Virtual Assistant *",
  "pl.aiTitle": "* AI Virtual Assistant — Included in all plans",
  "pl.aiDesc1": "All Aurora plans include",
  "pl.aiDesc2": ", our intelligent virtual assistant developed by Neurotech-X. It guides you step by step through the system, answers questions about modules, features, plans and settings, helps migrate data from other systems (Nex, Bling, Tiny, spreadsheets), and when needed opens support tickets automatically — all inside the system, in real time.",
  "pl.aiMore": "Want to know more about our AI solutions? Meet our virtual talents at",
  "pl.backToLogin": "← Back to login",
  "pl.descStarter": "Ideal for those just starting out.",
  "pl.descEssencial": "For growing businesses.",
  "pl.descPro": "Complete management with finance and reports.",
  "pl.descBusiness": "For robust multi-user operations.",
  "pl.descEnterprise": "Complete solution for large operations.",
  "tf.subscribePlan": "Subscribe to plan",
  "tf.createAccount": "Create account",
  "tf.planHint": "Your plan will be activated as soon as payment is processed. Meanwhile, enjoy full access!",
  "tf.fillHint": "Fill in your details to get started.",
  "tf.companyName": "Company name *",
  "tf.companyPh": "E.g.: John's Store",
  "tf.companyEmail": "Company email *",
  "tf.accessData": "Access Data",
  "tf.yourName": "Your name *",
  "tf.fullNamePh": "Full name",
  "tf.passwordPh": "Minimum 6 characters",
  "tf.passwordMin": "Password must be at least 6 characters",
  "tf.createError": "Error creating account",
  "tf.creating": "Creating your account...",
  "tf.createAndSubscribe": "Create account & subscribe",
  "ad.panel": "Admin Panel",
  "ad.deletePerm": "Delete Permanently",
  "ad.actives": "Active",
  "ad.canceled": "Canceled",
  "ad.loadingMetrics": "Loading metrics...",
  "ad.loadingPlans": "Loading plans...",
  "ad.loadingTenants": "Loading tenants...",
  "ad.supportTickets": "Support Tickets",
  "ad.createdAt": "Created at",
  "ad.adminPassPrompt": "Enter your admin password:",
  "ad.document": "Document",
  "ad.companyEmail": "Company Email *",
  "ad.masterEmail": "Master Email *",
  "ad.dashError": "Error loading dashboard",
  "ad.closeTicket": "Close Ticket",
  "ad.avgMrr": "Avg MRR per Tenant",
  "ad.maxUsers": "Max Users",
  "ad.modulesIncluded": "Included Modules",
  "ad.modulesEnabled": "Enabled modules",
  "ad.noTenants": "No tenants registered",
  "ad.noTenantsFound": "No tenants found",
  "ad.masterName": "Master Name *",
  "ad.planName": "Plan Name *",
  "ad.new30": "New (30 days)",
  "ad.popularPlan": "Most Popular Plan",
  "ad.planReq": "Plan *",
  "ad.plan": "Plan",
  "ad.monthlyPrice": "Monthly Price (R$) *",
  "ad.resetPass": "Reset password",
  "ad.selectPlan": "Select a plan",
  "ad.noPlan": "No plan",
  "ad.masterPass": "Master Password *",
  "ad.tenantsStatus": "Tenant Status",
  "ad.storage": "Storage (MB)",
  "ad.suspended": "Suspended",
  "ad.activeTenants": "Active Tenants",
  "ad.allStatus": "All statuses",
  "ad.totalTenants": "Total Tenants",
  "ad.masterUser": "Master User",
  "ad.totalUsers": "Total Users",
  "ad.users": "Users",
  "ad.lastLogin": "Last Login",
  "ad.recentTenants": "Latest Registered Tenants",
  "ad.allDataOf": "All data of",
  "ad.searchPh": "Search by name or email...",
  "ad.planDescPh": "Short plan description",
  "ad.planNamePh": "E.g.: Premium",
  "ad.replyPh": "Reply to client...",
  "ad.adminPassPh": "Admin password",
  "ad.closeTicketConfirm": "Close this ticket?"
};
